/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function FilterData(state = {}, action) {
    switch (action.type) {
    case ProductConstants.GET_PRODUCTS_FILTERS_SUCCESS:
        return {
            filters: action.user,
        };

    default:
        return state;
    }
}
